var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "#546587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2027 5.8321H8.51471V1.28884H9.32124V0H2.77867V1.28884H3.5852V5.8321H1.89721C0.851072 5.8321 0 6.64807 0 7.65096V19.2646C0 20.2676 0.851072 21.0835 1.89721 21.0835H2.68891V22H4.03327V21.0835H8.06673V22H9.41109V21.0835H10.2028C11.2489 21.0835 12.1 20.2675 12.1 19.2646V7.65096C12.0999 6.64807 11.2488 5.8321 10.2027 5.8321ZM4.03323 18.1335H2.68886V8.78214H4.03323V18.1335ZM6.72214 18.1335H5.37777V8.78214H6.72214V18.1335ZM7.17035 5.8321H4.92952V1.28884H7.17035V5.8321ZM9.41105 18.1335H8.06668V8.78214H9.41105V18.1335Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag_icon.60268f198ce2dd6e441f94c32dc29982.svg";
export { ForwardRef as ReactComponent };